import React, { useEffect, useState } from 'react';
import { useAccountNotifications } from 'hooks/use-account-notifications.hook';
import { InvisibleHeading } from 'styles';
import { copyFor } from 'config';
import { useAccountContext } from 'contexts/account';
import { NotificationCard } from '../../../dashboard/notifications/notification-card';
import { LoadingModule } from '../../../../components/loading';

export const RECONNECT_UTILITY_NOTIFICATION_KEY =
  'reconnect_utility_account_on_failed_email_override';
export const ReconnectUtilityNotificationComponent = () => {
  const { customerType } = useAccountContext();
  const isSMB = customerType === 'smb';
  const notificationsQuery = useAccountNotifications();
  const [isReconnectNotificationExist, setIsReconnectNotificationExist] =
    useState(false);
  const [reconnectNotification, setReconnectNotification] = useState(
    {} as QueriedNotification
  );

  const { loading } = notificationsQuery;

  useEffect(() => {
    if (!loading) {
      const reconnectUtilityAccountNotification = dashboardNotifications.find(
        notification =>
          notification.notificationKey === RECONNECT_UTILITY_NOTIFICATION_KEY
      );

      if (
        reconnectUtilityAccountNotification &&
        reconnectUtilityAccountNotification.active
      ) {
        setIsReconnectNotificationExist(true);
        setReconnectNotification(
          reconnectUtilityAccountNotification as QueriedNotification
        );
      }
    }
  }, []);

  if (loading) {
    return <LoadingModule variant="banner" />;
  }
  const { dashboardNotifications } = notificationsQuery.data;
  const getCopy = copyFor('dashboard.standardDashboard.notifications');

  <InvisibleHeading tag="h2">{getCopy('accessibleTitle')}</InvisibleHeading>;
  return isReconnectNotificationExist ? (
    <>
      <InvisibleHeading tag="h2">{getCopy('accessibleTitle')}</InvisibleHeading>
      <NotificationCard notification={reconnectNotification} isSMB={isSMB} />
    </>
  ) : null;
};
